import React, {useRef} from "../_snowpack/pkg/react.js";
import {Bar} from "../_snowpack/pkg/react-chartjs-2.js";
import {useTranslation} from "../_snowpack/pkg/react-i18next.js";
import {formatRupiah} from "../services/Formatters.js";
export const ROIChart = (props) => {
  const {t} = useTranslation();
  const colors = props.yearly.map((value) => value.cumulativeProfit < 0 ? "#DA7F7D" : "#F4D797");
  const mouseX = useRef(0);
  const data = {
    labels: props.yearly.map((x) => x.index),
    datasets: [
      {
        label: "Jt. Rupiah" + props.cacheBuster,
        data: props.yearly.map((x) => x.cumulativeProfit / 1e6),
        backgroundColor: colors,
        borderColor: "rgba(255, 99, 132, 0.2)"
      }
    ]
  };
  const title = (toolTipItems) => {
    const year = toolTipItems[0].label;
    return t("chart.tooltipTitle", {year});
  };
  const label = (toolTipItem) => {
    return formatRupiah(toolTipItem.raw * 1e6);
  };
  const footer = (toolTipItems) => {
    const year = toolTipItems[0].label;
    return year === `${props.inverterLifetimeInYears + 1}` ? t("chart.inverterReplacement") : "";
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        position: "nearest",
        intersect: false,
        callbacks: {
          title,
          label,
          footer
        }
      }
    },
    scales: {
      y: {
        title: {
          text: t("chart.labelProfit"),
          display: true
        },
        ticks: {
          callback: (val) => {
            return `${val}`;
          }
        }
      },
      x: {
        title: {
          text: t("chart.labelYear"),
          display: true
        },
        ticks: {
          minRotation: 0,
          maxRotation: 0
        }
      }
    }
  };
  const plugins = [
    {
      id: "verticalLine",
      afterEvent: (chart, args) => {
        const event = args.event;
        if (event.type === "mousemove") {
          mouseX.current = event.x ?? 0;
        }
      },
      afterDraw: (chart) => {
        const xAxis = chart.scales.x.left;
        const mouse = mouseX.current;
        const x = mouse < xAxis ? xAxis : mouse;
        const yAxis = chart.scales.y;
        const ctx = chart.ctx;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, yAxis.top);
        ctx.lineTo(x, yAxis.bottom);
        ctx.lineWidth = 1;
        ctx.strokeStyle = "#48709d";
        ctx.stroke();
        ctx.restore();
      }
    }
  ];
  const height = props.mobile ? 200 : 300;
  return /* @__PURE__ */ React.createElement("div", {
    style: {display: "block", minHeight: `${height}px`}
  }, /* @__PURE__ */ React.createElement(Bar, {
    data,
    options,
    plugins
  }));
};
